// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-n_fK","advertDetailHeaderPrice__value":"c-n_fL","advertDetailHeaderPrice__label":"c-n_fM"};